import { render, staticRenderFns } from "./withdrawalApproval.vue?vue&type=template&id=2bed11ae&scoped=true&"
import script from "./withdrawalApproval.vue?vue&type=script&lang=ts&"
export * from "./withdrawalApproval.vue?vue&type=script&lang=ts&"
import style0 from "./withdrawalApproval.vue?vue&type=style&index=0&id=2bed11ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bed11ae",
  null
  
)

export default component.exports